import { getDaysUntilExpiry } from "./subscriptionAlertUtils";
import {
  formatDashboardSubscription,
  getDashboardEntityCountry,
  getDashboardStripeLevelForEntity,
} from "./myCompaniesDashboardUtils";
import { isDefectShareAtLeast } from "./eventTotalsSaUtils";

export const MY_COMPANIES_REGION_CODES = ["RU", "BY", "KZ"];

export const DEFAULT_MY_COMPANIES_FILTERS = {
  subscription: "all",
  entityType: "all",
  errorsOnly: false,
  regions: { RU: true, BY: true, KZ: true },
  defectMin3: false,
};

export function matchesSubscriptionFilter(company, subscriptionFilter) {
  if (subscriptionFilter === "all") {
    return true;
  }
  const sub = formatDashboardSubscription(company.subscription_rel);
  if (subscriptionFilter === "yes") {
    return sub.isActive;
  }
  if (subscriptionFilter === "no") {
    return !sub.isActive;
  }
  if (subscriptionFilter === "expiring15") {
    if (!sub.isActive) {
      return false;
    }
    const validityDate = company.subscription_rel?.[0]?.validity_date;
    const days = getDaysUntilExpiry(validityDate);
    return typeof days === "number" && days <= 15;
  }
  return true;
}

function matchesEntityTypeFilter(company, entityType) {
  if (entityType === "all") {
    return true;
  }
  if (entityType === "partner") {
    return company.is_partner === true;
  }
  if (entityType === "company") {
    return company.is_partner !== true;
  }
  return true;
}

function matchesRegionFilter(company, regions) {
  const code = getDashboardEntityCountry(company);
  return Boolean(regions?.[code]);
}

/**
 * @param {Array} entities
 * @param {typeof DEFAULT_MY_COMPANIES_FILTERS} filters
 * @param {{
 *   canShowLicensedServers: boolean,
 *   serversPending: boolean,
 *   softAllData: Array,
 *   licensingAll: Array,
 *   eventTotalsByCompanyId: Map<number, { month?: object }>|null,
 *   eventTotalsLoading: boolean,
 * }} context
 */
export function applyMyCompaniesFilters(entities, filters, context) {
  if (!Array.isArray(entities)) {
    return [];
  }
  const f = filters ?? DEFAULT_MY_COMPANIES_FILTERS;

  return entities.filter((company) => {
    if (!matchesSubscriptionFilter(company, f.subscription)) {
      return false;
    }
    if (!matchesEntityTypeFilter(company, f.entityType)) {
      return false;
    }
    if (!matchesRegionFilter(company, f.regions)) {
      return false;
    }

    if (f.errorsOnly) {
      const stripe = getDashboardStripeLevelForEntity(company, {
        canShowLicensedServers: context.canShowLicensedServers,
        serversPending: context.serversPending,
        softAllData: context.softAllData,
        licensingAll: context.licensingAll,
      });
      if (stripe !== "red") {
        return false;
      }
    }

    if (f.defectMin3) {
      if (context.eventTotalsLoading) {
        return true;
      }
      const month =
        context.eventTotalsByCompanyId?.get(Number(company.id))?.month;
      if (!isDefectShareAtLeast(month, 3)) {
        return false;
      }
    }

    return true;
  });
}
